import axios from '../plugins/axios';
import officeAxios from '../plugins/office-axios';

export default {
  loadMenuInfoList() {
    const url = process.env.VUE_APP_HIWORKS_MENU_API + `/personal/menu`;
    const options = {};
    return axios.get(url, options);
  },
  loadPlatformMenuInfoList() {
    const url = process.env.VUE_APP_HIWORKS_MENU_API + `/personal/menu/platform`;
    const options = {};
    return axios.get(url, options);
  },
  loadRecentCount(domain) {
    let recentCountUrl = process.env.VUE_APP_OFFICE_URL + '/' + domain + '/common/menu/recent_count';
    const options = {};
    return officeAxios.get(recentCountUrl, options);
  },
  setMenuVisible(menuType, isVisible) {
    // isVisible와 show more은 반대이므로 !isVisible 형태로 request해야함
    let recentCountUrl = process.env.VUE_APP_HIWORKS_MENU_API + '/personal/menu/show-more';
    const data = {
      menu_type: menuType,
      show_more: isVisible,
    };
    return axios.put(recentCountUrl, data);
  },
  modifyMenuOrder(menuTypeList) {
    let recentCountUrl = process.env.VUE_APP_HIWORKS_MENU_API + '/personal/menu/order';
    let data = JSON.stringify(menuTypeList).replace(/\\/g, '');
    /// prototype.js 충돌 이슈로 인하여 아래 로직 필수
    if (data.charAt(data.length - 1) === '"') {
      data = data.substring(0, data.length - 1);
    }
    if (data.charAt(0) === '"') {
      data = data.substring(1, data.length);
    }
    return axios.put(recentCountUrl, data);
  },
};
